import React from 'react'
import { MultiSelect } from 'components'
import { useGetSubCategory } from 'hooks'

type SubCategoryProps = {
  subCategoryState: {
    subCategory: string[]
    division?: string[]
    category?: string[]
    reportName?: string
  }
  onChange(subCategory: string[], isDefaultAll?: boolean): void
  disabled?: boolean
}

export const SelectSubCategory = (props: SubCategoryProps) => {
  const { subCategoryState, onChange, disabled } = props
  const { subCategory, division = ['all'], category = ['all'], reportName } = subCategoryState

  const { getSubCategoryStatus, getIsSubCategoryLoading, subCategoryData, getSubCategoryError } = useGetSubCategory({
    division,
    category,
    reportName,
  })

  const isEnabled = !disabled && division.length && category.length

  const [fieldError, setFieldError] = React.useState('')
  const validateField = (setValidation: boolean = false) => {
    if (isEnabled) {
      if (getSubCategoryStatus === 'error') {
        return getSubCategoryError?.errorMessage ?? 'Network Error!'
      }
      if (!subCategory.length) {
        if (fieldError) return true
        else if (setValidation) setFieldError('triggered')
      }
    }
    return ''
  }
  const getErrorText = () => {
    const value = validateField()
    if (typeof value === 'string') return value
    return ''
  }

  const handleSubCategoryChange = (
    selectedSubCategories: string[],
    selectedSubCategoriesText: string[],
    isDefaultAll?: boolean
  ) => {
    onChange(selectedSubCategories, isDefaultAll)
  }

  return (
    <div className="w-full sm:w-64">
      <MultiSelect
        placeholder="Select sub-category"
        label="Sub-category *"
        id="sub-category"
        isLoading={getIsSubCategoryLoading}
        disabled={!isEnabled}
        value={subCategory}
        onChange={handleSubCategoryChange}
        options={(subCategoryData || []).map((item) => ({
          text: item.commercial_class,
          value: item.commercial_class,
        }))}
        onBlur={() => validateField(true)}
        error={!!validateField()}
        helperText={getErrorText()}
      />
    </div>
  )
}
